import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import { Menu, X } from 'lucide-react'; // Optional: use icons (install: npm install lucide-react)
import logo1  from '../assets/logoagro1.png';
import logo  from '../assets/logoagro.png';

const Navbar = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <nav className="navbar">
      <div className="navbar-brand">
  <img src={logo1} alt="Hygenic Agro Logo" className="navbar-logo" />
  <span>Hygenic Agro</span>
</div>


      <div className="menu-icon" onClick={toggleMenu}>
        {menuOpen ? <X size={28} /> : <Menu size={28} />}
      </div>

      <ul className={`navbar-links ${menuOpen ? 'open' : ''}`}>
        <li>
          <Link to="/" className={`navbar-link ${location.pathname === '/' ? 'active' : ''}`} onClick={toggleMenu}>
            Home
          </Link>
        </li>
        <li>
          <Link to="/products" className={`navbar-link ${location.pathname === '/products' ? 'active' : ''}`} onClick={toggleMenu}>
            Products
          </Link>
        </li>
        <li>
          <Link to="/contact" className={`navbar-link ${location.pathname === '/contact' ? 'active' : ''}`} onClick={toggleMenu}>
            Contact
          </Link>
        </li>
        <li>
          <Link to="/gallary" className={`navbar-link ${location.pathname === '/gallary' ? 'active' : ''}`} onClick={toggleMenu}>
            Gallery
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
